const video = {
  root: "vidéo",
  root_plural: "vidéos",
  begin_duration: "Durée de début",
  prestation: "Prestation",
};
export default video;
